module.exports = ".fixtable { \n    width: 90%;\n    table-layout: auto; }\n\n.space {\n    margin-bottom:10px;\n}\n\n/* .divider-vertical {\n    position: absolute;\n    top: -250px;\n    height: 100px;\n    border-left: 1px solid rgb(63, 63, 63);\n} */\n\n.column-header {\n    text-decoration: underline;\n}\n\n.ui-dialog-content {\n    padding: 0%;\n}\n\n.col-centered{\n    float: none;\n    margin: 0 auto;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-search/event-search.component.css
// module id = ./src/app/components/event-search/event-search.component.css
// module chunks = main